import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbProgressbarConfig } from '@ng-bootstrap/ng-bootstrap';
import { Placeholder } from 'src/app/models/workflow';
import { RequestBuilderService } from '../../../request-builder.service';
import { DocumentTypeEnum } from 'src/app/constants/document-type.enum';

@Component({
  selector: 'app-documentlistitem',
  templateUrl: './documentlistitem.component.html'
})
export class DocumentListItemComponent {

  private _document!: any
  get document(): any {
    return this._document;
  }

  @Input('document') set document(val: any) {
    this._document = val;
    if (val.documentType === "RegularPdf") this.showEditDocument = true;

    if (this.document.filetype?.toLocaleLowerCase() == ".xbrl") {
      this.document.uploadProgress = 0;
      this.document.progress = 100;
    }
    if (this.document.documentStatus === "Processing") {
      this.document.uploadProgress = 0;
    }
  }
  @Input('RequestIndex') position!: number;
  @Input('ItemsInRequest') itemsInRequest!: number;
  @Input('Attachment') attachment!: boolean;
  @Input('First') firstitem!: boolean;
  @Input('Last') lastitem!: boolean;
  @Input('SortingAllowed') sortingAllowed: boolean = true;
  @Input() showDocument: boolean = true;
  @Input('PlaceHolder') placeHolder!: Placeholder;
  @Output('DocumentChange') documentChange = new EventEmitter();
  @Output('DocumentDeleted') documentDeleted = new EventEmitter<string>();
  @Output('DocumentChangeOrder') documentChangeOrder = new EventEmitter();
  @Output('EnableDocumentChangeOrder') enableDocumentChangeOrder = new EventEmitter();
  @Output() openViewer: EventEmitter<any> = new EventEmitter<any>();
  @Output() editDoc: EventEmitter<any> = new EventEmitter<any>();
  instruction: string = "";
  error: string = "";
  state: number = 0;
  showgrip: boolean = false;
  showEditDocument: boolean = false;

  constructor(public config: NgbProgressbarConfig, private requestBuilderService: RequestBuilderService) {
    // constructor must not be empty. It's approved by a comment.
  }

  DocumentChange(event: Event) {
    this.documentChange.emit({ id: this.position, name: (event.target as HTMLInputElement).value })
  }

  EnableDocumentChangeOrder(position: number, id: string) {
    this.showgrip = true;
    this.enableDocumentChangeOrder.emit({ position: position, id: id });
  }

  DocumentDeleted(documentId: any) {
    this.documentDeleted.emit(documentId);
  }

  openPreview() {
    if (this.document && this.document.filetype.toLocaleLowerCase() == ".pdf") {
      this.requestBuilderService.OpenPDFViewer({ documentGuid: this.document.id, place: false, showEditDocument: true })
    } else if (this.document && (this.document.filetype.toLocaleLowerCase() == ".xbrl" || this.document.filetype.toLocaleLowerCase() == ".html")) {
      this.requestBuilderService.OpenXBRLViewer({ document: this.document })
    } else if (this.document.filetype.toLocaleLowerCase() == ".xml") {
      this.requestBuilderService.OpenXMLView({ document: this.document });
    }
  }

  editDocument() {
    this.editDoc.emit({ document: this.document });
  }
}
